import { FC, ReactElement } from 'react'

import { areDatesInSameMonth, formatDate } from '../../../../../helpers/date'
import { LoadingSpinner } from '../../../../components'
import { isSameDay } from '../../../../helpers/date'
import { TimeModeType } from '../../../../types'
import { DayBasis } from '../../models'
import { UserCalendarDay } from '../index'

import './UserCalendarDays.scss'

export interface UserCalendarDaysProps extends DayBasis {
    isLoading: boolean;
    selectedDays: Date[];
}

const UserCalendarDays: FC<UserCalendarDaysProps> = ({
    isLoading,
    selectedDays,
    absences,
    leaveOfAbsences,
    shifts,
    specialDays,
    tracks,
    unavailableToWorkTimeSlots,
    mode,
    showHeader,
    userId,
    onItemClick,
}): ReactElement => {
    const onAbsenceMouseEnter = (id: string) => {
        const elements = document.getElementsByClassName(`calendar-absence-${id}`)

        Array.from(elements).forEach(element => {
            element.classList.add('calendar-absence--active')
        })
    }

    const onAbsenceMouseLeave = (id: string) => {
        const elements = document.getElementsByClassName(`calendar-absence-${id}`)

        Array.from(elements).forEach(element => {
            element.classList.remove('calendar-absence--active')
        })
    }

    return (
        <>
            {selectedDays.map((day, index) => {
                const key = formatDate(day, 'yyyy-MM-dd')
                const outOfRange = mode === TimeModeType.month && ! areDatesInSameMonth(day, selectedDays[selectedDays.length - 1])
                const specialDaysMatches = specialDays.filter(specialDay => isSameDay(day, specialDay.date))

                return (
                    <UserCalendarDay
                        showDate
                        key={key}
                        userId={userId}
                        absences={absences}
                        leaveOfAbsences={leaveOfAbsences}
                        shifts={shifts}
                        tracks={tracks}
                        unavailableToWorkTimeSlots={unavailableToWorkTimeSlots}
                        index={index}
                        showHeader={index < 7 && showHeader}
                        specialDays={specialDaysMatches}
                        day={day}
                        mode={mode}
                        outOfRange={outOfRange}
                        last={selectedDays.length - 1 === index}
                        onItemClick={onItemClick}
                        onAbsenceMouseEnter={onAbsenceMouseEnter}
                        onAbsenceMouseLeave={onAbsenceMouseLeave}
                    />
                )
            })}

            {isLoading && (
                <LoadingSpinner className="user-calendar-days__loading-spinner" />
            )}
        </>
    )
}

export default UserCalendarDays
